// Dashboard polish — KPI count-up animation.
// Active only when html.e16-paint-dashboard is set.

const NUMBER_RE = /^[-+]?(\$|€|£|¥|EGP|USD|SAR|AED)?\s*[-+]?[\d,]+(\.\d+)?\s*(K|M|B)?$/i;

function parseNumber(str) {
	if (!str) return null;
	const txt = str.replace(/,/g, "").trim();
	const m = txt.match(/^[-+]?(?:\$|€|£|¥|EGP|USD|SAR|AED)?\s*([-+]?\d+(?:\.\d+)?)\s*(K|M|B)?$/i);
	if (!m) return null;
	let val = parseFloat(m[1]);
	const suf = (m[2] || "").toUpperCase();
	if (suf === "K") val *= 1000;
	else if (suf === "M") val *= 1_000_000;
	else if (suf === "B") val *= 1_000_000_000;
	return val;
}

function formatLike(template, value) {
	// Try to preserve the original prefix/suffix. Cheap approach: check for common K/M/B and currency.
	const lng = document.documentElement.getAttribute("lang") === "ar" ? "ar" : "en";
	const fmt = new Intl.NumberFormat(lng === "ar" ? "ar-EG" : "en-US", {
		maximumFractionDigits: 2,
		minimumFractionDigits: template.includes(".") ? 2 : 0,
	});
	const m = template.match(/^([^\d-+]*)([-+]?[\d,.\s]+)\s*(K|M|B)?(.*)$/i);
	if (!m) return fmt.format(value);
	const prefix = m[1];
	const suffix = m[3] || "";
	const tail = m[4] || "";
	let display = value;
	if (suffix.toUpperCase() === "K") display = value / 1000;
	else if (suffix.toUpperCase() === "M") display = value / 1_000_000;
	else if (suffix.toUpperCase() === "B") display = value / 1_000_000_000;
	return `${prefix}${fmt.format(display)}${suffix ? " " + suffix : ""}${tail}`;
}

function countUp(node) {
	if (node.dataset.e16CountUp === "1") return;
	if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;

	const final = (node.textContent || "").trim();
	const target = parseNumber(final);
	if (target === null || isNaN(target)) return;
	if (Math.abs(target) > 1e10) return; // sanity

	node.dataset.e16CountUp = "1";
	const duration = 700;
	const start = performance.now();
	const startVal = 0;

	function frame(now) {
		const t = Math.min(1, (now - start) / duration);
		const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
		const cur = startVal + (target - startVal) * eased;
		node.textContent = formatLike(final, cur);
		if (t < 1) requestAnimationFrame(frame);
		else node.textContent = final;
	}
	requestAnimationFrame(frame);
}

function findNumbers() {
	return Array.from(document.querySelectorAll(
		".number-card .number, .number-card-container .widget-content, " +
		".widget.number-card-widget-box .number, " +
		".dashboard-card .number, .e16-kpi-value"
	));
}

function animateAll() {
	if (!document.documentElement.classList.contains("e16-paint-dashboard")) return;
	findNumbers().forEach(countUp);
}

export const dashboardPolish = {
	mount() {
		setTimeout(animateAll, 600);
		setTimeout(animateAll, 1500);

		try {
			if (window.frappe && frappe.router) {
				frappe.router.on("change", () => {
					setTimeout(animateAll, 500);
					setTimeout(animateAll, 1300);
				});
			}
		} catch (e) {}
	},
};
